import { IncomeType } from '@/types/rentalApplication';
import { AVAILABLE_CITIES } from '@/constants/cities';
import { z } from 'zod';

export const rentalApplicationSchema = z
  .object({
    firstname: z.string().min(1, { message: 'Förnamn är obligatoriskt.' }),
    lastname: z.string().min(1, { message: 'Efternamn är obligatoriskt.' }),
    ssn: z
      .string()
      .min(1, { message: 'Personnummer är obligatoriskt.' })
      .transform(val => val.replace(/\D/g, ''))
      .pipe(
        z
          .string()
          .length(12, { message: 'Personnummer måste vara 12 siffror (ÅÅÅÅMMDDXXXX).' })
          .regex(/^\d{12}$/, { message: 'Personnummer får endast innehålla siffror.' })
      ),
    phoneNumber: z.string().min(1, { message: 'Telefonnummer är obligatoriskt.' }),
    email: z.string().email({ message: 'Ogiltig e-postadress.' }),
    city: z.enum(AVAILABLE_CITIES, { message: 'Välj en stad.' }),
    incomeMonthly: z.string().min(1, { message: 'Månadsinkomst är obligatoriskt.' }),
    incomeType: z.nativeEnum(IncomeType),
    employer: z.string().min(1, { message: 'Arbetsgivare är obligatoriskt.' }),
    hasCurrentLandlord: z.boolean(),
    landlordName: z.string().optional(),
    landlordPhone: z.string().optional(),
    rentMin: z.string().min(1, { message: 'Lägsta hyra är obligatoriskt.' }),
    rentMax: z.string().min(1, { message: 'Högsta hyra är obligatoriskt.' }),
    smoker: z.boolean(),
    pets: z.string(),
    children: z.string(),
    additionalInfo: z.string(),
  })
  .refine(
    data => {
      if (data.hasCurrentLandlord) {
        return !!data.landlordName;
      }
      return true;
    },
    {
      message: 'Hyresvärdens namn krävs om du har en nuvarande hyresvärd.',
      path: ['landlord_name'],
    }
  )
  .refine(
    data => {
      if (data.hasCurrentLandlord) {
        return !!data.landlordPhone;
      }
      return true;
    },
    {
      message: 'Hyresvärdens telefon krävs om du har en nuvarande hyresvärd.',
      path: ['landlord_phone'],
    }
  )

  .refine(data => Number(data.rentMax) >= Number(data.rentMin), {
    message: 'Högsta hyra måste vara större än eller lika med lägsta hyra.',
    path: ['rent_max'],
  });
